
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {}
})
export default class ManageGrowthModule extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/3da5772b8a4bdd3433181957b8237aa1.png";
  pic2 = "/img/0d7e0be9d0ecc4d0bac5dac2c188f7a1.png";
  pic3 = "/img/a25c79853f260e25e9e7c93c2660ec36.png";
  pic4 = "/img/aed636797016aa59fc8f7b869c9bc22b.png";
}
